import { FC, Fragment } from "react";
import EllipsesMenuNutritionDialog from "../molecules/EllipsesMenuNutritionDialog";
import { Meal } from "@/app/nutrition/meal.enum";

export type DishListItemProps = {
  isLoading?: boolean;
  dish?: any;
  onSetDish?: (dish: any, meal: Meal) => void;
  onlySelect?: boolean;
};

export const DishListItem: FC<DishListItemProps> = ({
  isLoading,
  dish,
  onSetDish,
  onlySelect,
}) => {
  return (
    <>
      <div key={dish?.id} className="flex border border-gray-200 rounded-md">
        <ul
          role="list"
          className="list-none flex flex-col p-4 flex-1 flex-shrink-0 w-full h-full items-start justify-start"
        >
          {isLoading ? (
            <Fragment>
              <li className={`flex w-full gap-x-4 items-center mb-2`}>
                <div className="h-1.5 w-1.5 flex-shrink-0 flex-grow-0 rounded-full bg-gray-100 ring-1 ring-gray-300" />
                <div className="w-full bg-gray-300 animate-pulse rounded-sm h-4"></div>
              </li>
              <li className={`flex w-full gap-x-4 items-center mb-2`}>
                <div className="h-1.5 w-1.5 flex-shrink-0 flex-grow-0 rounded-full bg-gray-100 ring-1 ring-gray-300" />
                <div className="w-3/4 bg-gray-300 animate-pulse rounded-sm h-4"></div>
              </li>
              <li className={`flex w-full gap-x-4 items-center`}>
                <div className="h-1.5 w-1.5 flex-shrink-0 flex-grow-0 rounded-full bg-gray-100 ring-1 ring-gray-300" />
                <div className="w-1/2 bg-gray-300 animate-pulse rounded-sm h-4"></div>
              </li>
            </Fragment>
          ) : (
            <Fragment>
              {dish.products?.map((product, index) => (
                <li
                  key={index}
                  className={`flex w-full gap-x-4 items-center ${index < dish.products.length - 1 ? "mb-2" : ""}`}
                >
                  <div className="h-1.5 w-1.5 flex-shrink-0 flex-grow-0 rounded-full bg-gray-100 ring-1 ring-gray-300" />
                  <p className="flex-auto text-sm text-gray-500">
                    <span className=" text-gray-700">{product}</span>
                  </p>
                </li>
              ))}
            </Fragment>
          )}
        </ul>

        <div className="display flex-shrink-0 flex items-start">
          <EllipsesMenuNutritionDialog
            onSelect={
              onlySelect ? () => onSetDish(Meal.Breakfast, dish) : undefined
            }
            onBreakFast={
              !onlySelect ? () => onSetDish(Meal.Breakfast, dish) : undefined
            }
            onMediaMana={
              !onlySelect ? () => onSetDish(Meal.Lunch, dish) : undefined
            }
            onLunch={!onlySelect ? () => onSetDish(Meal.Meal, dish) : undefined}
            onSnack={
              !onlySelect ? () => onSetDish(Meal.Snack, dish) : undefined
            }
            onDinner={
              !onlySelect ? () => onSetDish(Meal.Dinner, dish) : undefined
            }
            onPoscena={
              !onlySelect ? () => onSetDish(Meal.Redinner, dish) : undefined
            }
          />
        </div>
      </div>
    </>
  );
};
